<template>
  <div>
    <h1>Login!</h1>
  </div>
</template>
<script>
export default {
  methods: {
    getTokens: function (routeHash) {
      var tokens = {accessToken: null, idToken: null}
      if (routeHash.length > 0) {
        // Strip leading #
        console.log('strip leading #')
        if (routeHash[0] === '#') {
          routeHash = routeHash.substring(1)
          console.log('stripped')
        }
        let hashParams = routeHash.split('&')
        console.log(`routeHash: ${routeHash}`)
        console.log(`hashParams: ${hashParams}`)
        for (let i in hashParams) {
          let param = hashParams[i]
          let keyValue = param.split('=')
          if (keyValue[0] === 'id_token') {
            tokens.idToken = keyValue[1]
          } else if (keyValue[0] === 'access_token') {
            tokens.accessToken = keyValue[1]
          }
        }
      } else {
        console.log('hash length is zero!')
      }
      return tokens
    },
    // Entry point for the login callback.
    // This method intercepts the tokens sent from the IdP
    doLogin: function () {
      // console.log('cognito client id: ', process.env.COGNITO_USER_POOL_CLIENT_ID)

      // For details of the $route object,
      // see https://router.vuejs.org/api/#route-object-properties.
      console.log(this.$route)
      console.log(this.$route.hash)
      console.log(this.$route.params)
      console.log(this.$route.query)
      let tokens = this.getTokens(this.$route.hash)
      // TODO: if one of the tokens isn't set, display an error.
      sessionStorage.accessToken = tokens.accessToken
      sessionStorage.idToken = tokens.idToken
      // To remove things from session storage:
      //    sessionStorage.removeItem('foo')
      /*
      Auth notes:
        - A link to cognito login url in the app
          - https://docs.aws.amazon.com/cognito/latest/developerguide/login-endpoint.html
        - randomly generate (and store) `state`, passing it through the cognito login process
          - see https://auth0.com/docs/protocols/oauth2/oauth-state
          - basically, we generate it, store it locally in session storage, call the auth url,
            and then verify the state when we receive the login success callback
        - csrf double submit cookie defense?
          - whatever this is
        - Cookie storage, httpOnly flag, secure flag
          - makes cookies not accessible by js code
      */
      // https://auth.larsbutler.net/login?client_id=oh50653grlfillgabmoad6ce&
      /*
      https://auth.larsbutler.net/login?response_type=token&client_id=roh50653grlfillgabmoad6ce&redirect_uri=https://larsbutler.net/login/callback&state=1dcefb2a40e64919a12dabaed00eb591&scope=foo+bar+baz+openid+profile+aws.cognito.signin.user.admin
      https://auth.larsbutler.net/login?response_type=token&client_id=bv1fm6d3tq9t87im31h7do7dd&redirect_uri=https://larsbutler.net/login/callback&state=1dcefb2a40e64919a12dabaed00eb591&scope=openid+profile+aws.cognito.signin.user.admin
      */
    }
  },
  beforeMount: function () {
    this.doLogin()
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/LoginCallback.vue